export default __webpack_public_path__ + "static/media/Dial_Black.de4ebfd0.png";